/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MonitoredStations } from '../../models/monitored-stations';

export interface GetMonitoredStations$Params {
}

export function getMonitoredStations(http: HttpClient, rootUrl: string, params?: GetMonitoredStations$Params, context?: HttpContext): Observable<StrictHttpResponse<MonitoredStations>> {
  const rb = new RequestBuilder(rootUrl, getMonitoredStations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MonitoredStations>;
    })
  );
}

getMonitoredStations.PATH = '/custom/stations/monitored';
